export function init(){

  // wait for the floor loaded event
  cube.event.on('async-content:AssistanceFloor', () => {

    // rebind collapse
    const floor = cube.$id('AssistanceFloor');
    floor.$('.title-floor').on('click', () => {
      const isCollapsed = !floor.$('.floor-content-holder').classList.contains('in');
      const ariaValue = isCollapsed ? 'false' : 'true';
      const collapseValue = isCollapsed ? 'show' : 'hide';

      if (cube.ui.isMobile()) {
        $(floor.$('.floor-content-holder')).collapse(collapseValue);
        floor.$('.title-floor').setAttribute('aria-expanded', ariaValue);
      }
    });

    $(window).on('enter-small-screen', () => {
      $(floor.$('.floor-content-holder')).collapse('show');
      floor.$('.title-floor').setAttribute('aria-expanded', 'false');
    });

  });
}



// WEBPACK FOOTER //
// ./src/catalog/product-details/assistance-floor.js